import { setDefaultOptions } from 'date-fns';
import { da, enGB } from 'date-fns/locale';
import { Texts } from './Common/Texts';
import { Utils } from './Common/Utils';

const formatRelativeLocale: any = {
    lastWeek: Texts.get('dateFnsLongDateTimeFormat'),
    yesterday: Texts.get('dateFnsLongDateTimeFormat'),
    today: Texts.get('dateFnsTodayRelativeFormat'),
    tomorrow: Texts.get('dateFnsTomorrowRelativeFormat'),
    nextWeek: Texts.get('dateFnsLongDateTimeFormat'),
    other: Texts.get('dateFnsLongDateTimeFormat'),
};

const cultureQuery = Utils.getParameterByName('culture');
const cultureCookie = decodeURIComponent(
    Utils.getCookie('.AspNetCore.Culture'),
);

if (cultureQuery == 'en' || cultureCookie == 'c=en|uic=en') {
    const locale = {
        ...enGB,
        formatRelative: (token: string) => formatRelativeLocale[token],
    };
    setDefaultOptions({ locale: locale });
} else {
    const locale = {
        ...da,
        formatRelative: (token: string) => formatRelativeLocale[token],
    };
    setDefaultOptions({ locale: locale });
}
